const state = {
    loginDialog: false,
    dialogType: 'login', // 默认为登录框，也可以为 'register' 表示注册框
    userInfo: {}
}

const mutations = {
    SET_LOGIN_DIALOG(state, visible) {
        state.loginDialog = visible
    },
    SET_DIALOG_TYPE(state, type) {
        state.dialogType = type
    },
    SET_USER_INFO(state, info) {
        state.userInfo = info
    }
}

const actions = {
    showLoginDialog({ commit }) {
        commit('SET_DIALOG_TYPE', 'login')
        commit('SET_LOGIN_DIALOG', true)
    },
    showRegisterDialog({ commit }) {
        commit('SET_DIALOG_TYPE', 'register')
        commit('SET_LOGIN_DIALOG', true)
    },
    hideLoginDialog({ commit }) {
        commit('SET_LOGIN_DIALOG', false)
    },
    setUserInfo({commit}, info) {
        commit('SET_USER_INFO', info)
    },
    clearUserInfo({commit}) {
        commit('SET_USER_INFO', {})
    }
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/login.js